/**
 * Password Validation Utility
 * Strong password requirements:
 * - Minimum 8 characters
 * - At least one uppercase letter
 * - At least one lowercase letter
 * - At least one number
 * - At least one special character
 */

export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

export const passwordRequirements = [
  { test: (pwd) => pwd.length >= 8, message: 'At least 8 characters' },
  { test: (pwd) => /[a-z]/.test(pwd), message: 'At least one lowercase letter' },
  { test: (pwd) => /[A-Z]/.test(pwd), message: 'At least one uppercase letter' },
  { test: (pwd) => /\d/.test(pwd), message: 'At least one number' },
  { test: (pwd) => /[@$!%*?&]/.test(pwd), message: 'At least one special character (@$!%*?&)' },
];

export const validatePassword = (password) => {
  const errors = [];

  passwordRequirements.forEach(({ test, message }) => {
    if (!test(password)) {
      errors.push(message);
    }
  });

  return {
    isValid: errors.length === 0,
    errors
  };
};

export const getPasswordStrength = (password) => {
  if (!password) return { strength: 0, label: 'None' };

  let score = 0;

  // Length score
  if (password.length >= 8) score += 1;
  if (password.length >= 12) score += 1;

  // Complexity score
  if (/[a-z]/.test(password)) score += 1;
  if (/[A-Z]/.test(password)) score += 1;
  if (/\d/.test(password)) score += 1;
  if (/[@$!%*?&]/.test(password)) score += 1;

  const strengthMap = {
    0: { strength: 0, label: 'Very Weak', color: '#dc3545' },
    1: { strength: 17, label: 'Very Weak', color: '#dc3545' },
    2: { strength: 33, label: 'Weak', color: '#fd7e14' },
    3: { strength: 50, label: 'Fair', color: '#ffc107' },
    4: { strength: 67, label: 'Good', color: '#20c997' },
    5: { strength: 83, label: 'Strong', color: '#28a745' },
    6: { strength: 100, label: 'Very Strong', color: '#198754' },
  };

  return strengthMap[Math.min(score, 6)];
};

export default {
  passwordRegex,
  passwordRequirements,
  validatePassword,
  getPasswordStrength
};
